import type { ReactNode } from "react";

export interface DenialScreenProps {
  title?: string;
  message?: ReactNode;
}

export function DenialScreen({ title, message }: DenialScreenProps = {}): JSX.Element {
  return (
    <div role="alert" className="denial">
      <h1>{title ?? "Not available"}</h1>
      {message ? (
        <p>{message}</p>
      ) : (
        <p>
          This app needs a 2nd Skies Terminal or PFP membership tier that includes it. If you&rsquo;ve
          just upgraded, wait a few minutes and reopen. To see what each tier includes, visit{" "}
          <a href="https://2ndskiestrading.com/the-pfp-system/" target="_blank" rel="noopener noreferrer">
            https://2ndskiestrading.com/the-pfp-system/
          </a>
          .
        </p>
      )}
    </div>
  );
}
